import { render, staticRenderFns } from "./OfficeSendAs.vue?vue&type=template&id=32b2dae9&scoped=true"
import script from "./OfficeSendAs.vue?vue&type=script&lang=js"
export * from "./OfficeSendAs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b2dae9",
  null
  
)

export default component.exports